// extracted by mini-css-extract-plugin
export default {"loadwrapp":"Loading_loadwrapp__BW2DT","line":"Loading_line__xIon+","load":"Loading_load__KKKeV","loadingA":"Loading_loadingA__uRKEh","l-1":"Loading_l-1__Mz-Lt"};